import { StyleSheet } from 'react-native';
import type { Theme } from '../../../theme/getTheme';

export const getLateJoinBannerStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: 10,
      padding: 12,
      borderRadius: 14,
      borderWidth: 1,
      borderColor: theme.accent,
      backgroundColor: theme.background.cardElevated,
    },
    iconWrap: {
      width: 28,
      height: 28,
      borderRadius: 14,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.background.card,
    },
    textWrap: {
      flex: 1,
      gap: 2,
    },
    title: {
      fontSize: 14,
      fontWeight: '800',
      color: theme.gray[900],
    },
    body: {
      fontSize: 12,
      fontWeight: '500',
      lineHeight: 16,
      color: theme.gray[600],
    },
    dismissButton: {
      padding: 4,
      borderRadius: 12,
    },
    dismissButtonHover: {
      backgroundColor: theme.background.card,
    },
  });
